import {Box, Checkbox, NumberField} from "@mbank-design/design-system/components";
import React, {useContext, useState} from "react";
import {AdditionalSupportContext} from "./AdditionalSupportContext";


export default function ParkingSection() {
    const [checked, setChecked] = useState(false);
    const {showParking, parkingCount, onParkingCountChange} = useContext(AdditionalSupportContext);
    
    const onValueChange = (value: string) => {
        onParkingCountChange!(parseInt(value, 10));
    }
    
    const onCheckedChange = () => {
        if (checked)
            onParkingCountChange!(0);
        else
            onParkingCountChange!(1);
        
        setChecked(!checked);
    }

    if (showParking) {
        return (
            <>
                <Checkbox checked={checked} onChange={onCheckedChange} label={"parking"} />
                {checked ? (
                    <Box maxWidth={300}>
                        <NumberField value={parkingCount} onChange={onValueChange} label={"how many spaces?"} isStepperVisible />
                    </Box>
                ) : (<></>)}

            </>
        )
    } else return <></>
    
}